import { render, staticRenderFns } from "./modalEditarImagen.vue?vue&type=template&id=120a4eaf&scoped=true"
import script from "./modalEditarImagen.vue?vue&type=script&lang=js"
export * from "./modalEditarImagen.vue?vue&type=script&lang=js"
import style0 from "./modalEditarImagen.vue?vue&type=style&index=0&id=120a4eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a4eaf",
  null
  
)

export default component.exports